export default "__VITE_ASSET__CtmRcO4i__"